import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-not-autorization',
    templateUrl: './serverOffLine.component.html',
    standalone: true
})
export class ServerOffLineComponent implements OnInit {
  router = inject(Router);

  ngOnInit(): void {
    this.router.navigate(['/']);
  }
}
